import * as React from "react";
import Spinner from "../../components/Spinner";
import { Link } from "react-router-dom";
import { ReactSortable } from "react-sortablejs";
import { sortArticle } from "../../utils";
import AddNewArticleBtn from "./AddNewArticleBtn";
import { EXCLUDED_IDS_FROM_MENU } from "../../utils/config";

class ManageArticleListScreen extends React.Component {
  componentDidMount() {
    const {
      articles: { articleList },
      getArticleList,
    } = this.props;
    if (articleList !== null) return;
    getArticleList();
  }

  reorderComponent = (articles, sortable, store) => {
    if (sortable === null) return;

    articles.forEach((art, order) => {
      const {
        articles: { articleList },
        updateLocalArticle,
        updateArticleData,
      } = this.props;
      const editedArticle = articleList.find(
        (article) => article.id === art.id
      );

      if (editedArticle && editedArticle.order === order) return;

      updateArticleData({ ...art, order });
      updateLocalArticle({ ...art, order });
    });
  };
  renderElement = (article, key, submenuElement = true) => (
    <Link
      key={`${key}${article.id}`}
      className={`list-group-item ${submenuElement && "ml-2 background-gray"}`}
      to={{
        pathname: "manage-article-detail",
        article,
      }}
    >
      {article.title}
    </Link>
  );

  render() {
    const { articleList } = this.props.articles;
    if (articleList === null) return <Spinner />;
    const mainArticles = articleList
      .filter((article) => !article.parentId)
      .filter((article) => EXCLUDED_IDS_FROM_MENU.indexOf(article.id) === -1)

      .sort(sortArticle);

    const customArticleList = articleList.filter(
      (art) => EXCLUDED_IDS_FROM_MENU.indexOf(art.id) !== -1
    );

    return (
      <React.Fragment>
        <div className="list-group">
          <div className="alert alert-info pb-0 pt-2">
            <p>Złap i przeciągnij aby zmienić kolejność</p>
            <p>Skorzystaj z przycisku "Dodaj artykuł" aby utworzyć nowy</p>
          </div>
          <ReactSortable
            list={mainArticles}
            setList={this.reorderComponent}
            animation={0}
          >
            {mainArticles.map((article, key) => {
              const childArticles = articleList
                .filter((art) => art.parentId && art.parentId === article.id)
                .sort(sortArticle);

              return (
                <div key={`parentArticle${article.id}`}>
                  {this.renderElement(article, key, false)}
                  <div>
                    <ReactSortable
                      key={`child_${article.id}`}
                      animation={0}
                      list={childArticles}
                      setList={this.reorderComponent}
                    >
                      {childArticles.map(this.renderElement)}
                    </ReactSortable>
                  </div>
                </div>
              );
            })}
          </ReactSortable>
          <div className="mt-3">
            Inne artykuły:
            {customArticleList.map((art) => this.renderElement(art, 0, false))}
          </div>
        </div>

        <AddNewArticleBtn />
      </React.Fragment>
    );
  }
}

export default ManageArticleListScreen;



// WEBPACK FOOTER //
// ./src/screens/ManageArticle/ManageArticleListScreen.js